import React from "react";
import PortfolioContainer from "./components/PortfolioContainer";
import "./App.css";

function App() {
  return (
        <PortfolioContainer/>
  );
}

export default App;
